import gql from 'graphql-tag';

import client from '../graphqlAPI';

/*
Edits a radio show. `input` carries ONLY the fields the editor changed: the backend
validates and writes just those, so legacy rows stay editable (see utils/radioShowForm.js).
*/
const POST_EDIT_RADIO_SHOW = gql`
  mutation postEditRadioShow($id: Int!, $input: RadioShowInput!) {
    postEditRadioShow(id: $id, input: $input) {
      isAuth
      ok
      errors { field message }
      show {
        _id
        id
        parent
        parentSlug
        parentTitle { es ca en pt }
        slug
        title { es ca en pt }
        subtitle { es ca en pt }
        text { es ca en pt }
        status
        highlight
        channel
        image
        imageSquare
        mp3
        fileSize
        mixcloud
        youtube
        spotify
        isPlaylist
        duration
        lang
        appleCategory
        appleSubcategory
        tagIds
        categoryIds
        firstAirDate
        airings { id date channel }
        createdAt
        updatedAt
      }
    }
  }
`;

const postEditRadioShow = async ({ id, input }) => {
  try {
    const result = await client
      .mutate({
        mutation: POST_EDIT_RADIO_SHOW,
        variables: { id, input },
        fetchPolicy: 'no-cache',
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const {
      data: { postEditRadioShow: postEditRadioShowData },
    } = result;

    if (postEditRadioShowData) {
      return postEditRadioShowData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: postEditRadioShow = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: postEditRadioShow Error: ${error}`);
    return null;
  }
};

export default postEditRadioShow;
